import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "scrollRight",
    "scrollLeft",
    "mobileLabels"
  ]

  connect() {
    this.mobileSteps = this.element.querySelectorAll("[data-mobile-step]");

    var initialStep = this.element.querySelector("[data-current-step]");
    this.scrollToStep(initialStep);
    setTimeout(() => {
      this.element.classList.remove("opacity-0");
    }, 250);
  }

  screenCenter() {
    return window.innerWidth / 2;
  }

  stepCenter(step) {
    var stepRect = step.getBoundingClientRect();
    return stepRect.left + stepRect.width / 2;
  }

  scrollLeft() {
    // Find the first menu item that is to the left of the screen center, and scroll to place it in the center.
    var selectedStep = null;
    for (var i = 0; i < this.mobileSteps.length; i++) {
      var step = this.mobileSteps[i];
      // Add 2 to avoid rounding errors
      if (this.stepCenter(step) < (this.screenCenter() - 2)) {
        selectedStep = step;
      }
    }
    this.scrollToStep(selectedStep);
  }

  scrollRight() {
    // Find the first menu item that is to the right of the screen center, and scroll to place it in the center.
    var selectedStep = null;
    for (var i = 0; i < this.mobileSteps.length; i++) {
      var step = this.mobileSteps[i];
      // Add 2 to avoid rounding errors
      if (this.stepCenter(step) > (this.screenCenter() + 2)) {
        selectedStep = step;
        break;
      }
    }
    this.scrollToStep(selectedStep);
  }

  scrollToStep(selectedStep) {
    if (selectedStep) {
      var delta = this.stepCenter(selectedStep) - this.screenCenter();
      this.mobileLabelsTarget.style.marginLeft = (parseFloat(this.mobileLabelsTarget.style.marginLeft || 0) - delta) + 'px';

      // If we reached the last step, hide the right arrow.
      this.refreshArrows(selectedStep);
    }
  }

  refreshArrows(selectedStep) {
    if (selectedStep == this.mobileSteps[0]) {
      this.scrollLeftTarget.classList.add("hidden");
    } else {
      this.scrollLeftTarget.classList.remove("hidden");
    }

    if (selectedStep == this.mobileSteps[this.mobileSteps.length - 1]) {
      this.scrollRightTarget.classList.add("hidden");
    } else {
      this.scrollRightTarget.classList.remove("hidden");
    }
  }
}